import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "../../lib/api";

export default function CampaignsRail() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/campaigns");
        if (alive) setRows((data || []).slice(0, 3));
      } catch {
        /* silent — rail simply hides */
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  if (!rows.length) return null;

  return (
    <section
      className="px-6 md:px-12 lg:px-24 py-16 bg-[hsl(var(--kb-surface-alt))]"
      data-testid="home-campaigns-rail"
    >
      <div className="flex items-end justify-between mb-8 flex-wrap gap-3">
        <div>
          <div className="overline mb-2">Curated Edits</div>
          <h2 className="font-display text-3xl lg:text-4xl">Shop our seasonal stories.</h2>
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {rows.map((c) => (
          <Link
            key={c.id}
            to={`/campaign/${c.slug}`}
            className="relative aspect-[4/5] overflow-hidden group block"
            data-testid={`home-campaign-${c.slug}`}
          >
            {c.hero_image_url && (
              <img
                src={imgUrl(c.hero_image_url)}
                alt={c.title}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 text-white">
              {c.hero_eyebrow && (
                <div className="overline text-white/80 mb-2">{c.hero_eyebrow}</div>
              )}
              <div className="font-display text-2xl md:text-3xl leading-tight mb-2">{c.title}</div>
              {c.subtitle && (
                <p className="text-sm text-white/80 line-clamp-2 mb-3">{c.subtitle}</p>
              )}
              <span className="text-xs uppercase tracking-widest underline">
                {c.hero_cta_label || "Explore →"}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
